import React from 'react';
import { ProgressBarContainer } from './style'

type ProgressBarProps = {
    currentStep?: number;
    totalSteps?: number;
}

const ProgressBar = ({currentStep, totalSteps}:ProgressBarProps) => {
  return (
    <ProgressBarContainer progress={currentStep} totalSteps={totalSteps}>
            <div className="bar" />
    </ProgressBarContainer>
  )
}

export default ProgressBar;
